import { render, staticRenderFns } from "./ImageZoom.vue?vue&type=template&id=273adf71&scoped=true"
import script from "./ImageZoom.vue?vue&type=script&lang=js"
export * from "./ImageZoom.vue?vue&type=script&lang=js"
import style0 from "./ImageZoom.vue?vue&type=style&index=0&id=273adf71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273adf71",
  null
  
)

export default component.exports